import { useTheme as useEmotionTheme } from '@emotion/react'

export function useTheme() {
  return useEmotionTheme()
}
